/**
 * Base schema resolver.
 * This pure function transforms detail objects to Helmet-ready schema object.
 */
const resolver = (obj, type) => obj && ({
  type: 'application/ld+json',
  innerHTML: JSON.stringify({
    '@context': 'http://schema.org',
    '@type': type,
    ...obj,
  }),
});

export default resolver;



// WEBPACK FOOTER //
// ./app/src/state/resolvers/schema/index.js